import { ensureGeofences } from "../../../../../../../services/useOrgData";
import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import BtnSecondary from "../../../../../../../component/SecondaryButton";
import GeofenceDialog from "../../../../../../../component/GeoFenceDialog";
import GoogleMapWithPolyline from "../../../../../../../component/GoogleMapPolyline";

import { useNotify } from "../../../../../../../component/NotificationProvider";
import { tokens } from "../../../../../../../theme";

// Office geofence editor embedded in the attendance policy form. The fence is
// stored per legal unit; this is where it's drawn, right beside the toggle that
// activates enforcement. Shown only when geo-fencing is enabled.
const GeofenceField = () => {
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [startLocation, setStartLocation] = useState([]);
  const [endLocation, setEndLocation] = useState([]);
  const [middleLocations, setMiddleLocations] = useState([]);

  const fetchGeofence = async () => {
    setLoading(true);
    try {
      const list = await ensureGeofences();
      const fences = list?.[0]?.geofenceObj?.fences?.[0];
      if (fences?.length > 0) {
        setStartLocation([{ latitude: fences[0].lat, longitude: fences[0].lng }]);
        setEndLocation([{ latitude: fences[0].lat, longitude: fences[0].lng }]);
        setMiddleLocations(fences.length > 2
          ? fences.slice(1).map((f) => ([{ latitude: f.lat, longitude: f.lng }]))
          : []);
      } else {
        setStartLocation([]); setEndLocation([]); setMiddleLocations([]);
      }
    } catch (error) {
      notify.error(error?.message || "Failed to load geofence");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchGeofence(); /* eslint-disable-next-line */ }, []);

  const hasFence = startLocation.length > 0;

  return (
    <Box sx={{ border: `1px solid ${tokens.border}`, borderRadius: "12px", p: "1rem 1.25rem", mt: "0.5rem" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: hasFence ? "1rem" : 0 }}>
        <Box>
          <Box sx={{ fontSize: "0.875rem", fontWeight: 600, color: tokens.text }}>Office geofence</Box>
          <Box sx={{ fontSize: "0.8125rem", color: tokens.textMuted, mt: "0.25rem" }}>
            {hasFence ? "Clock-in is restricted to inside this boundary." : "No boundary drawn yet — clock-in won't be restricted until you set one."}
          </Box>
        </Box>
        <BtnSecondary onClick={() => setDialogOpen(true)} sx={{ borderRadius: "8px", whiteSpace: "nowrap" }}>
          {hasFence ? "Edit geofence" : "Set geofence"}
        </BtnSecondary>
      </Box>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: "2rem" }}><CircularProgress size={24} /></Box>
      ) : hasFence && (
        <GoogleMapWithPolyline
          startLocation={startLocation}
          endLocation={endLocation}
          middleLocations={middleLocations}
          defaultColor="#8C3B5E"
          defaultZoom={14}
          sx={{ width: "100%", height: "22rem", borderRadius: "10px" }}
        />
      )}

      <GeofenceDialog open={dialogOpen} onClose={() => { setDialogOpen(false); fetchGeofence(); }} />
    </Box>
  );
};

export default GeofenceField;
